import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const { user, booted } = useAuth();
  if (!booted) return null;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
